import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import RemovablePill from '@Components/RemovablePill';
import { focusAfterPillRemoval } from '../treeViewDialogFocus';

function SelectedSearchItemTag({ item, index = 0, onClickThesaurusItem }) {
  const title = item.get('title') || 'Selected search item';

  return (
    <RemovablePill
      data-e2e="selected-search-item-remove"
      label={title}
      onRemove={() => {
        // Move focus before the click destroys this button, otherwise the
        // re-render leaves focus on <body>.
        focusAfterPillRemoval(index);
        onClickThesaurusItem(item);
      }}>
      {title}
    </RemovablePill>
  );
}

SelectedSearchItemTag.propTypes = {
  item: PropTypes.instanceOf(Map).isRequired,
  /** DOM position of this pill in the selected list; used for focus handling. */
  index: PropTypes.number,
  onClickThesaurusItem: PropTypes.func.isRequired,
};

export default SelectedSearchItemTag;
